import * as React from "react";

import {
  CheckboxDescription,
  FooterNote,
  SettingsFormDiv,
  SettingsInputItem,
} from "../../../../App/Common/Components/FormComponents";
import { fullCourseViews } from "../../../../utils/courseViews";
import { ICourseEditOperations, ICourseSettings, IFullCourse } from "../../../course-author/types";
import Checkbox from "../Checkbox";

export interface IEnforceLinearProgressionProps {
  course: IFullCourse;
  editOperations: ICourseEditOperations;
}

export interface IEnforceLinearProgressionState {
  linearProgression: boolean;
}

export default class EnforceLinearProgression extends React.Component<
  IEnforceLinearProgressionProps,
  IEnforceLinearProgressionState
> {
  constructor(props: IEnforceLinearProgressionProps) {
    super(props);
  }
  public toggleLinear = () => {
    this.props.editOperations.modifyCourseLinearity();
  };
  public render() {
    const settings = fullCourseViews.settings(this.props.course) as ICourseSettings;
    return (
      <SettingsFormDiv>
        <SettingsInputItem>
          <label>
            <Checkbox defaultChecked={settings.linear} onChange={this.toggleLinear} />
            <CheckboxDescription>Enforce linear progression</CheckboxDescription>
          </label>
        </SettingsInputItem>
        <FooterNote>
          By default, learners are free to take the units of a course in whatever order they wish. If you'd rather
          learners take the course from top to bottom, this option lets you enforce that behaviour.
        </FooterNote>
      </SettingsFormDiv>
    );
  }
}
